import { millisecondsInDay as i } from "./constants.js";
import { startOfDay as n } from "./startOfDay.js";
import { getTimezoneOffsetInMilliseconds as o } from "./_lib/getTimezoneOffsetInMilliseconds.js";
function l(s, a) {
  const t = n(s), e = n(a), r = +t - o(t), f = +e - o(e);
  return Math.round((r - f) / i);
}
export {
  l as default,
  l as differenceInCalendarDays
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/date-fns@3.6.0/~/date-fns/differenceInCalendarDays.js
// module id = 1340
// module chunks = 41